// Minimal utility to update cart item links with linked product URLs
import { MakeGraphQLQuery } from './helpers';
import { GRAPHQL_API_ENDPOINT } from './constants';

const updateLinkedProductUrls = async () => {
  // Get all product links in the cart
  const productLinks = document.querySelectorAll('[data-product-handle]');
  if (productLinks.length === 0) return;

  // Extract unique product handles
  const productHandles = [...new Set(Array.from(productLinks).map(link => 
    link.getAttribute('data-product-handle')
  ))];

  try {
    // Fetch linked product data from Storefront API
    const linkedProductUrls = {};
    
    // Query each product individually for better reliability
    for (const handle of productHandles) {
      try {
        const query = `{
          product(handle:"${handle}") {
            handle
            metafield(namespace: "global", key: "linked_product") {
              value
            }
          }
        }`;

        const response = await MakeGraphQLQuery(GRAPHQL_API_ENDPOINT, query);

        if (!response.data?.product) continue;

        const product = response.data.product;
        
        if (product?.metafield?.value) {
          const metafieldValue = product.metafield.value;
          
          // Check if it's a Shopify GID (gid://shopify/Product/123456789)
          if (metafieldValue.startsWith('gid://shopify/Product/')) {
            const productId = metafieldValue.split('/').pop();
            
            // Fetch the product handle using the ID
            try {
              const productQuery = `{
                product(id: "gid://shopify/Product/${productId}") {
                  handle
                }
              }`;
              
              const productResponse = await MakeGraphQLQuery(GRAPHQL_API_ENDPOINT, productQuery);
              if (productResponse.data?.product?.handle) {
                linkedProductUrls[handle] = `/products/${productResponse.data.product.handle}`;
              }
            } catch (error) {
              console.warn(`Could not fetch product handle for ID ${productId}:`, error);
            }
          } else {
            try {
              // Try to parse as JSON
              const linkedProductData = JSON.parse(metafieldValue);
              if (linkedProductData.handle) {
                linkedProductUrls[handle] = `/products/${linkedProductData.handle}`;
              } else if (linkedProductData.url) {
                linkedProductUrls[handle] = linkedProductData.url;
              }
            } catch (e) {
              // If not JSON, assume it's a handle or URL
              if (metafieldValue.startsWith('/') || metafieldValue.startsWith('http')) {
                linkedProductUrls[handle] = metafieldValue;
              } else {
                linkedProductUrls[handle] = `/products/${metafieldValue}`;
              }
            }
          }
        }
      } catch (error) {
        console.warn(`Could not fetch metafield for product ${handle}:`, error);
      }
    }

    // Update the links
    productLinks.forEach(link => {
      const handle = link.getAttribute('data-product-handle');
      
      // Find the cart item container to check line item properties
      const cartItem = link.closest('.cart-list-item');
      if (!cartItem) return;
      
      // Check if this is a sample using the data-sample attribute
      const isSample = cartItem.getAttribute('data-sample') === 'true';
      
      // Only update if it's a sample and we have a linked product URL
      if (isSample && linkedProductUrls[handle]) {
        link.href = linkedProductUrls[handle];
        link.classList.add('linked-product');
      }
    });

  } catch (error) {
    console.warn('Could not update linked product URLs:', error);
  }
};

// Export for use in other files
export { updateLinkedProductUrls }; 